export const IS_ACTIVE_SHOP_KEY = 'is-active-shop';
